import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize, map, Observable, tap } from 'rxjs';
import { GhiseuModuleService } from '../ghiseul-unic-settings/ghiseu-module/ghiseu-module.service';
import { AddProgramareService } from '../cereri/add-programare/add-programare.service';
import { helper } from 'src/environments/helper';

import * as moment from 'moment-timezone';
// import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
// import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
// import { ComponentPortal } from '@angular/cdk/portal';
import { ProgramariService } from '../programari/programari.service';
import { IAppointment } from '../programari/programari.interface';
import { Location } from '@angular/common';
import { CereriService } from '../cereri/cereri.service';
import { ICerere } from '../cereri/cereri.interface';
import { NotificationService } from 'src/app/services/notification.service';
import { Generic } from 'src/app/interfaces/generic.interface';


const TIMEZONE = 'Europe/Bucharest';
const DAY_OF_WEEK_DATE_FORMAT = 'dddd, Do MMMM YYYY';
const DAY_OF_WEEK_FORMAT = 'dddd';
const DAY_OF_WEEK_SHORT_FORMAT = 'ddd';
const DATE_FORMAT = 'Do MMMM YYYY'
const DATE_SHORT_FORMAT = 'Do';
const MONTH_FORMAT = 'MMMM';
const MONTH_YEAR_FORMAT = 'MMMM YYYY';
const TIME_FORMAT = 'HH:mm';

const TO_MINUTES_DIVISOR = 1000 * 60;

const SLOT_HEIGHT_PX = 58;

const WORKDAY_BEGINS_AT_HOUR = 8;

@Component({
    selector: 'app-programari-view',
    templateUrl: './programari-view.component.html',
    styleUrls: ['./programari-view.component.scss']
})
export class ProgramariViewComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    helper = helper;
    isLoading = false;
    isLoadingAppointments = false;
    moduleId!: number;
    locatieId!: number;
    serviciiId: number = -1;
    tipProblemaId = -1;
    tipProgramareId: number = -1;
    moduleName: string = '';
    moduleSlug: string = '';
    durataProgramareModul: number = 5;
    appointments: IAppointment[] = [];
    locatii$!: Observable<Generic[]>;
    servicii$!: Observable<Generic[]>;
    tipuriProblema$!: Observable<Generic[]>;
    tipuriProgramare$!: Observable<Generic[]>;

    selectedId: number | null = null;
    selectedAppointment: IAppointment | null = null;
    cerere: ICerere | null = null;

    viewing = false;

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private moduleService: GhiseuModuleService,
        private programariService: ProgramariService,
        private addProgramareService: AddProgramareService,
        private cereriService: CereriService,
        private notificationService: NotificationService,
        private _location: Location,
    ) {
        route.queryParams.subscribe(params => {
            this.moduleId = Number(params['moduleId']);
            this.locatieId = Number(params['locatieId']);

            console.log('moduleId', this.moduleId);
            console.log('locatieId', this.locatieId);

            this.getData();
        });
    }

    loadModuleData(moduleId: number) {
        this.isLoading = true;
        this.moduleService
            .getModul(moduleId)
            .pipe(finalize(() => this.isLoading = false))
            .subscribe((result: any) => {
                this.moduleName = result.data.name;
                this.moduleSlug = result.data.slug;
            })
    }

    findLocatiiByModul(moduleId: number) {
        this.isLoading = true;
        this.locatii$ = this.addProgramareService.getLocatiiByModul(moduleId).pipe(
            map((res: any) => {
                const data = (res?.data || []).map((item: any) => ({
                    id: item.id,
                    name: item.name,
                }));
                return [...data];
            }),
            finalize(() => (this.isLoading = false))
        );
    }

    onLocatieChange(locatieId: number): void {
        // Reset dependent fields
        this.serviciiId = -1;
        this.tipProblemaId = -1;
        this.tipProgramareId = -1;

        // Reset dependent observables
        this.tipuriProblema$ = new Observable<Generic[]>((observer) => {
            observer.next([this.defaultParameter]);
            observer.complete();
        });
        this.tipuriProgramare$ = new Observable<Generic[]>((observer) => {
            observer.next([this.defaultParameter]);
            observer.complete();
        });

        if (this.moduleId > 0 && locatieId > 0) {
            this.loadServicii(this.moduleId, locatieId);
        } else {
            this.servicii$ = new Observable<Generic[]>((observer) => {
                observer.next([this.defaultParameter]);
                observer.complete();
            });
        }

        this.closeView();
        this.router.navigate(['/ghiseul-unic-programari-view'], { queryParams: { moduleId: this.moduleId, locatieId: this.locatieId } });
        this.loadAppointments(this.startMoment, this.endMoment);
    }

    loadServicii(moduleId: number, locatieId: number) {
        this.isLoading = true;
        this.servicii$ = this.addProgramareService.getServiciiByModulLocatie(moduleId, locatieId).pipe(
            map((res: any) => {
                const data = (res?.data || []).map((item: any) => ({
                    id: item.id,
                    name: item.web_name || item.name,
                }));
                return [this.defaultParameter, ...data];
            }),
            tap((servicii) => {
                // Auto-select if single option (excluding default parameter)
                const realData = servicii.filter(s => s.id !== -1);
                if (realData.length === 1) {
                    this.serviciiId = realData[0].id;
                    this.onServiciuChange(this.serviciiId);
                }
            }),
            finalize(() => (this.isLoading = false))
        );
    }

    onServiciuChange(serviciuId: number): void {
        // Reset dependent fields
        this.tipProblemaId = -1;
        this.tipProgramareId = -1;

        if (serviciuId > 0) {
            this.loadTipuriProblema(serviciuId);
            this.loadTipuriProgramare(this.moduleId, this.locatieId, serviciuId);
        } else {
            this.tipuriProblema$ = new Observable<Generic[]>((observer) => {
                observer.next([this.defaultParameter]);
                observer.complete();
            });
            this.tipuriProgramare$ = new Observable<Generic[]>((observer) => {
                observer.next([this.defaultParameter]);
                observer.complete();
            });
        }

        this.loadAppointments(this.startMoment, this.endMoment);
    }

    loadTipuriProblema(serviciuId: number) {
        this.tipuriProblema$ = this.addProgramareService.getTipuriProblemaByServiciu(serviciuId).pipe(
            map((res: any) => {
                const data = (res?.data || []).map((item: any) => ({
                    id: item.id,
                    name: item.name,
                }));
                return [this.defaultParameter, ...data];
            }),
            tap((tipuri) => {
                // Auto-select if single option (excluding default parameter)
                const realData = tipuri.filter(t => t.id !== -1);
                if (realData.length === 1) {
                    this.tipProblemaId = realData[0].id;
                    this.loadAppointments(this.startMoment, this.endMoment);
                }
            })
        );
    }

    loadTipuriProgramare(moduleId: number, locatieId: number, serviciuId: number) {
        this.tipuriProgramare$ = this.addProgramareService.getTipuriProgramByConfig(moduleId, locatieId, serviciuId).pipe(
            map((res: any) => {
                const data = (res?.data || []).map((item: any) => ({
                    id: item.id,
                    name: item.name,
                }));
                return [this.defaultParameter, ...data];
            }),
            tap((tipuri) => {
                // Auto-select if single option (excluding default parameter)
                const realData = tipuri.filter(t => t.id !== -1);
                if (realData.length === 1) {
                    this.tipProgramareId = realData[0].id;
                    this.loadAppointments(this.startMoment, this.endMoment);
                }
            })
        );
    }

    loadAppointments(startDate: moment.Moment, endDate: moment.Moment) {
        this.isLoadingAppointments = true;

        const payload = {
            id_modul: this.moduleId,
            id_locatie: this.locatieId,
            id_servicii: this.serviciiId && this.serviciiId !== -1 ? this.serviciiId : null,
            id_tip_problema: this.tipProblemaId && this.tipProblemaId !== -1 ? this.tipProblemaId : null,
            id_tip_program: this.tipProgramareId && this.tipProgramareId !== -1 ? this.tipProgramareId : null,
            date_from: startDate.format('YYYY-MM-DD'),
            date_to: endDate.format('YYYY-MM-DD'),
        }
        this.programariService
            .listSchedule(payload)
            .pipe(finalize(() => this.isLoadingAppointments = false))
            .subscribe((result) => {
                this.appointments = result.data;

                this.durataProgramareModul = this.appointments.length ? this.appointments[0].duration : 5;
                console.log('appointments', this.appointments);
            })
    }

    navigateBack() {
        this.router.navigate(['/ghiseul-unic-settings']);
    }

    getData() {
        this.loadModuleData(this.moduleId);

        this.findLocatiiByModul(this.moduleId);

        if (this.locatieId) {
            this.onLocatieChange(this.locatieId);
        }
    }

    getCerereInfo(appointment: IAppointment) {
        this.isLoading = true;
        this.cereriService
            .getCerere(appointment.cerere_data.id_cerere)
            .pipe(map((response: any) => response.data))
            .subscribe({
                next: (cerereData: ICerere) => {
                    this.isLoading = false;
                    this.cerere = cerereData;

                    this.openView(appointment);
                },
                error: (error: any) => {
                    this.isLoading = false;
                    console.error('Error', error);
                    let msg;
                    try {
                        msg = error.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService
                        .warningSwal(this.errorTitle, msg, this.errorIcon)
                        .then((result) => {
                            this.closeView();
                        });
                }
            });
    }

    hideWeekends = false;
    hideRejectedAppointments = true;
    daysToSubtractFromWeek = 0;

    dateFormats = {
        dayOfWeek: DAY_OF_WEEK_FORMAT,
        dayOfWeekShort: DAY_OF_WEEK_SHORT_FORMAT,
        date: DATE_FORMAT,
        dayOfWeekDate: DAY_OF_WEEK_DATE_FORMAT,
        month: MONTH_FORMAT,
        dateShort: DATE_SHORT_FORMAT,
        monthYear: MONTH_YEAR_FORMAT,
        time: TIME_FORMAT
    }

    startMoment = moment().locale('ro').tz(TIMEZONE).startOf('isoWeek');
    endMoment = moment().locale('ro').tz(TIMEZONE).endOf('isoWeek').subtract(this.daysToSubtractFromWeek, 'days');

    focusedMoment = this.startMoment;
    hours = ['08', '09', '10', '11', '12', '13', '14', '15', '16', '17'];

    get minuteHeightPx() {
        const minuteHeightPx = SLOT_HEIGHT_PX / parseInt(this.durataProgramareModul.toString(), 10);
        return minuteHeightPx;
    }

    get days() {
        const days = new Array(7 - this.daysToSubtractFromWeek).fill('').map((v, i) => moment(this.startMoment).add(i, 'days'));
        return days;
    }

    get timespanStarts() {
        const generatedMinute: number[] = []

        for (let currentValue = 0; currentValue < 60; currentValue += this.durataProgramareModul) {
            generatedMinute.push(currentValue);
        }

        return generatedMinute.map(minut => {
            if (minut < 10) {
                return '0' + minut.toString()
            } else {
                return minut.toString()
            }
        })
    }

    toggleWeekends() {
        if (this.hideWeekends) {
            this.daysToSubtractFromWeek = 0;
            this.hideWeekends = false;
        } else {
            this.daysToSubtractFromWeek = 2;
            this.hideWeekends = true;
        }
    }

    toggleRejectedAppointments() {
        this.hideRejectedAppointments = !this.hideRejectedAppointments;
    }

    trackByFn(index: number) {
        return index;
    }

    today() {
        this.startMoment = moment().locale('ro').tz(TIMEZONE).startOf('isoWeek');
        this.endMoment = moment().locale('ro').tz(TIMEZONE).endOf('isoWeek').subtract(this.daysToSubtractFromWeek, 'days');
        this.focusedMoment = this.startMoment;

        this.loadAppointments(this.startMoment, this.endMoment);
    }

    isToday(_moment: moment.Moment) {
        const isToday = _moment.isSame(new Date(), 'day');
        return isToday;
    }

    toIsoDay(day: moment.Moment) {
        const isoDay = day.format('YYYY-MM-DD').substr(0, 10);
        return isoDay;
    }

    appointmentStyle(appointment: IAppointment) {
        const dayStartMoment = moment(appointment.time_from).tz(TIMEZONE).startOf('day').add(WORKDAY_BEGINS_AT_HOUR, 'hours');
        const diffFromStartOfDay = new Date(appointment.time_from).getTime() - dayStartMoment.toDate().getTime();
        const diffFromStartOfDayMinutes = diffFromStartOfDay / TO_MINUTES_DIVISOR;
        const appointmentTopPx = diffFromStartOfDayMinutes * this.minuteHeightPx;

        const diffFromStartOfAppointment = new Date(appointment.time_end).getTime() - new Date(appointment.time_from).getTime();
        const diffFromStartOfAppointmentMinutes = diffFromStartOfAppointment / TO_MINUTES_DIVISOR;
        // console.log(`SchedulerComponent -> appointmentStyle -> diffMinutes`, diffMinutes);

        const appointmentHeightPx = diffFromStartOfAppointmentMinutes * this.minuteHeightPx;
        // console.log(`SchedulerComponent -> appointmentStyle -> this.minuteHeightPx`, this.minuteHeightPx);
        return { 'height.px': appointmentHeightPx, 'top.px': appointmentTopPx };
    }

    appointmentClass(appointment: IAppointment) {
        const dayStartMoment = moment(appointment.time_from).tz(TIMEZONE).startOf('day').add(WORKDAY_BEGINS_AT_HOUR, 'hours');
        const todayMoment = moment().locale('ro').tz(TIMEZONE);

        if (dayStartMoment.toDate().getTime() < todayMoment.toDate().getTime()) {
            return { 'past': true };
        }

        const createdAtBeforeDSTIds = [  // What is this ?????
            "605c44bcb58e8c05198f2342",
        ];

        return { 'confirmed': appointment.status === 'confirmed', 'rejected': appointment.status === 'rejected', 'pending': appointment.status === 'pending', 'createdAtBeforeDST': createdAtBeforeDSTIds.includes(appointment.id.toString()) }
    }

    filterAppointments(appointments: IAppointment[], day: moment.Moment) {
        if (!appointments) {
            return [];
        }

        return appointments.filter((a) => {
            const isCorrectDay = a.date === this.toIsoDay(day);
            const isRejected = a.status === 'rejected';

            if (this.hideRejectedAppointments) {
                return isCorrectDay && !isRejected;
            } else {
                return isCorrectDay;
            }
        });
    }

    prevWeek() {
        this.startMoment = this.startMoment.subtract(7, 'days');
        this.endMoment = this.endMoment.subtract(7, 'days');
        this.focusedMoment = this.startMoment;

        this.loadAppointments(this.startMoment, this.endMoment);
    }

    nextWeek() {
        this.startMoment = this.startMoment.add(7, 'days');
        this.endMoment = this.endMoment.add(7, 'days');
        this.focusedMoment = this.startMoment;

        this.loadAppointments(this.startMoment, this.endMoment);
    }

    upperCaseEachFirstLetter(s: any) {
        const regex = /(\b[a-z](?!,))/ug;
        const replaced = s.replace(regex, (x: string) => x.toUpperCase());
        return replaced;
    }

    formatDateString_uppercase(dateString: string) {
        const upperCaseEachFirstLetterFormattedMoment = this.upperCaseEachFirstLetter(dateString);
        return upperCaseEachFirstLetterFormattedMoment;
    }

    formatDate(date: Date, format: string) {
        const _moment = moment(date).tz(TIMEZONE);
        const dateString = this.formatMoment(_moment, format);
        return dateString;
    }

    formatMoment(_moment: moment.Moment, format: string) {
        const dateString = _moment.format(format);
        const dateStringUppercase = this.formatDateString_uppercase(dateString);
        return dateStringUppercase;
    }

    get formattedStartMoment() {
        const formattedMoment = this.formatMoment(this.startMoment, this.dateFormats.dayOfWeekDate);
        return formattedMoment;
    }

    get formattedEndMoment() {
        const formattedMoment = this.formatMoment(this.endMoment, this.dateFormats.dayOfWeekDate);
        return formattedMoment;
    }

    get formattedMonthYear() {
        const formattedMonthYear = this.formatMoment(this.startMoment, this.dateFormats.monthYear);
        return formattedMonthYear;
    }

    get formattedStartDateEndDate() {
        const formattedStartDateEndDate = `${this.formatMoment(this.startMoment, this.dateFormats.date)} - ${this.formatMoment(this.endMoment, this.dateFormats.date)}`;
        return formattedStartDateEndDate;
    }

    get formattedMonth() {
        const formattedMonth = this.formatMoment(this.startMoment, this.dateFormats.month);
        return formattedMonth;
    }

    get formattedDays() {
        const formattedDays = this.days.map((d) => this.formatMoment(d, this.dateFormats.dayOfWeekDate));
        return formattedDays;
    }

    openView(appointment: IAppointment) {
        this.viewing = true;
        this.selectedId = appointment.id;
        this.selectedAppointment = appointment;
    }

    closeView() {
        this.viewing = false;
        this.selectedId = null;
        this.selectedAppointment = null;
        this.cerere = null;
    }
}
